import React from "react";

const foo = (ticker, type) => {
  return `<iframe
  src="https://api.voxmarkets.co.uk/v2/widgets/rns/${ticker}/${type}/1"
  width="350px"
  height="200px"
  background="#ffffff"
  frameborder="0"
  scrolling="no"
/>`;
};

class Creator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      widget: "rns",
      ticker: "Vod",
      type: 1
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.generate = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    console.log("Submitr");
  }

  render() {
    return (
      <div>
        <h1>Widget generator</h1>
        <form onSubmit={this.onSubmit}>
          <label>
            Ticker
            <input
              type="text"
              name="ticker"
              value={this.state.ticker}
              onChange={e => {
                this.setState({ ticker: e.target.value });
              }}
            />
          </label>
          <label>
            Type
            <select
              value={this.state.type}
              onChange={e => {
                this.setState({ type: e.target.value });
              }}
            >
              <option value="1">Tide</option>
              <option value="2">Normal</option>
              <option value="3">Wide</option>
            </select>
          </label>
          <label>
            Width
            <input
              type="text"
              name="width"
              value={this.state.width}
              onChange={e => {
                this.setState({ width: e.target.value });
              }}
            />
          </label>
        </form>

        <h2>Code</h2>
        <div>
          <textarea
            rows={10}
            cols={150}
            defaultValue={foo(this.state.ticker, this.state.type)}
          />
        </div>

        <h2>Preview</h2>
        <div>
          <div
            dangerouslySetInnerHTML={{
              __html: foo(this.state.ticker, this.state.type)
            }}
          />
        </div>
      </div>
    );
  }
}

export default Creator;
